import { useMemo } from 'react';
import { formatLongDateTimeString } from '@bymason/utils';
import { Box, Card, CardContent, Stack } from '@bymason-private/legacy-pattern-components';

import { DeviceStatus } from '@bymason/controller-api-hooks';
import { LegacyDetailsList } from '@bymason-private/controller-shared-widgets';

interface PendingActionsViewProps {
  deviceStatus?: DeviceStatus | void;
}

export function PendingActionsView({ deviceStatus }: PendingActionsViewProps) {
  const pendingActions = useMemo(() => {
    const actions = deviceStatus?.pendingNotifications || [];

    return actions.map((act) => {
      const { id, targets, command, arguments: args, date: requested, expiration } = act;

      return {
        id,
        targets: targets.join(', ') || 'none',
        command,
        args: args.join(', ') || 'none',
        requested: formatLongDateTimeString(requested),
        expires: formatLongDateTimeString(expiration),
      };
    });
  }, [deviceStatus]);

  return (
    <Stack width='100%' pt={2} spacing={2}>
      {pendingActions.length ? (
        pendingActions.map((pa) => (
          <Card key={pa.id} variant='outlined'>
            <CardContent sx={{ '& li': { overflowX: 'hidden' } }}>
              <LegacyDetailsList
                items={[
                  { label: 'ID', value: pa.id },
                  { label: 'Receiving Apps', value: pa.targets },
                  { label: 'Command', value: pa.command },
                  { label: 'Args', value: pa.args },
                  { label: 'Requested', value: pa.requested },
                  { label: 'Expires', value: pa.expires },
                ]}
              />
            </CardContent>
          </Card>
        ))
      ) : (
        <Box p={3}>No pending actions</Box>
      )}
    </Stack>
  );
}
